<template>
    <div class="ecm-item-categories" :class="{'ecm-item-categories-list': showLabels}">
        
        <h2 v-if="categories && showLabels">{{ $t("categories") }}</h2>

        <ul v-if="categories">
            <li 
                v-for="category in categories"
                :key="'category-' + category.id">
                <img 
                    :src="getCategoryIcon(category.icon)"
                    :alt="category.name" 
                />
                <span v-if="showLabels">{{ category.name }}</span>
            </li>
            <!-- svg-injector 
                v-for="category in categories"
                :key="'category-' + category.id"
                :src="getCategoryIcon(category.icon)"
                :alt="category.name">
            </svg-injector -->
        </ul>

    </div>
</template>

<script>
//import { eventBus } from '../main.js';
//import { store } from '../store/store';

export default {
    name: 'ItemCategories',
    components: {
        
    },
    props: {
        categories: null,
        showLabels: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {

        }
    },

    methods: {
        getCategoryIcon(iconUrl) {
            if (iconUrl) {
                if (this.themeColor && this.themeTextColor) {
                    // Theme colors are set, get icon url via global method to set the color params
                    iconUrl = this.$setIconUrl(iconUrl, this.themeColor, this.themeTextColor);
                }
                if (iconUrl.indexOf('?') === -1) {
                    return iconUrl + '?v=2021-09-29';
                }
                return iconUrl + '&v=2021-09-29';
            }
            return null;
        }
    }
}

</script>

<style scoped>

</style>
